import script from "./PostSignUpForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PostSignUpForm.vue?vue&type=script&setup=true&lang=js"

import "./PostSignUpForm.vue?vue&type=style&index=0&id=4a56d145&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snedson-auth-backend/snedson-auth-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a56d145"]])

export default __exports__